var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"smartTown"}},[_c('div',{staticClass:"title"},[_vm._v("医院智慧管理分级评估标准体系（试行）")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("医院智慧管理是“三位一体”医疗健康建设的重要组成部分。为指导各地、各医院加强医疗健康建设的顶层设计，充分利用智慧管理工具，提升医院管理精细化、智能化水平，特制定医院智慧管理分级评估标准体系。")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.toLink()}}},[_vm._v("查看详情")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7293bce2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/news8.vue
// module id = null
// module chunks = 